







































































































































import Vue from 'vue'
import LeftSidebarLayout from '@/components/LeftSidebarLayout'
import CastTemplateDetails from '@/components/CastTemplateDetails'
import CreateEditCastTemplate from '@/components/CreateEditCastTemplate'
import { Table, TableColumn, Button } from 'element-ui'
import moment from 'moment'
import { CastTemplate } from '@/types/casttemplates'
import { UserProfile } from '@/types/users'
import { Stream } from '@/types/streams'
import { AssetGroup } from '@/types/assets'
import { LogMessage } from '@/store/modules/logs'
import './CastTemplates.scss'
import { WATERMARK_DEFAULT } from '@/store/types'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
import { KeyDict } from '@/types'

interface CastTemplateRow extends CastTemplate {
  lowercaseName?: string
}

export default Vue.extend({
  name: 'CastTemplates',
  computed: {
    canReadTemplates () : boolean {
      return this.$can(AbilityAction.Read, AbilitySubject.CastTemplates)
    },
    canEditTemplates () : boolean {
      return this.$can(AbilityAction.Edit, AbilitySubject.CastTemplates)
    },
    canDeleteTemplates () : boolean {
      return this.$can(AbilityAction.Delete, AbilitySubject.CastTemplates)
    },
    doOps (): boolean {
      return this.$can(AbilityAction.Do, AbilitySubject.Ops)
    },
    templates (): CastTemplateRow[] {
      const templates = this.$store.direct.state.castTemplates.templates
      return templates.map((template) => ({ ...template, lowercaseName: template.name.toLowerCase() }))
    },
    currentTeam (): UserProfile[] {
      return this.$store.direct.state.team.currentTeam
    },
    teamStreams (): { [ streamId: string ]: Stream } {
      return this.$store.direct.state.team.streams
    },
    folderList (): AssetGroup[] {
      return Object.values(this.$store.direct.state.assets.folderList)
    },
    activeTeam (): string {
      return this.$store.direct.state.team.activeTeam
    },
    maxAllowedNumIngests (): KeyDict<KeyDict<number>> {
      return this.$store.direct.getters.events.numIngests
    },
  },
  watch: {
    activeTeam (newVal) {
      if (newVal !== '') {
        this.$store.direct.dispatch.assets.subscribeTeamAssetGroup(newVal)
      }
    }
  },
  data: () => ({
    selectedTemplate: {},
    showCreateCastTemplateModal: false
  }),
  mounted () {
    if (this.activeTeam !== '') {
      this.$store.direct.dispatch.assets.subscribeTeamAssetGroup(this.activeTeam)
    }
  },
  beforeDestroy () {
    this.$store.direct.dispatch.assets.unsubscribeTeamAssetGroup(this.activeTeam)
  },
  methods: {
    heavyDutyNecessary (template: CastTemplate): string {
      const numInputs = Object.keys(template.input_streams).length
      const resolution = '' + parseInt(template.quality.split('p')[0])
      const framerate = parseFloat(template.framerate.replace('Hz', ''))
      const fps = framerate > 30 ? '60' : '30'
      const allowedInputs = this.maxAllowedNumIngests[resolution][fps]
      return numInputs > allowedInputs ? 'necessary' : 'not necessary'
    },
    showEditTemplate (template: CastTemplate) {
      this.selectedTemplate = template
      this.showCreateCastTemplateModal = true
    },
    async updateTemplate (templateName: string) {
      const tmpTemplate = JSON.parse(JSON.stringify(this.selectedTemplate))
      tmpTemplate.name = templateName
      tmpTemplate.watermark = WATERMARK_DEFAULT
      // console.log(tmpTemplate)
      await this.$store.direct.dispatch.castTemplates.updateCastTemplate(tmpTemplate)
      this.showCreateCastTemplateModal = false
      this.$message({
          type: 'success',
          message: 'Event template updated'
        })
    },
    deleteTemplate (templateId: string) {
      this.$confirm('Are you sure you want to delete this event template?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$store.direct.dispatch.castTemplates.deleteCastTemplate(templateId)
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
        const payload : LogMessage = {
          message: 'Delete event template initiated',
          castTemplate: templateId,
          level: 'info'
        }
        this.$store.direct.dispatch.logs.addLog(payload)
      }).catch(() => {})
    },
    getUser (paramId): string {
      const user = this.currentTeam.find(member => member.user_id === paramId)
      return user !== undefined && user.first_name !== undefined && user.last_name !== undefined ? `${user.first_name} ${user.last_name}` : ''
    },
    getFormattedDate (seconds) {
      return moment(seconds * 1000).format('M/D/YYYY')
    }
  },
  components: {
    LeftSidebarLayout,
    CastTemplateDetails,
    CreateEditCastTemplate,
    'el-button': Button,
    'el-table': Table,
    'el-table-column': TableColumn,
  }
})
